import React, { useEffect, useState } from 'react';
import { Card, Typography, Spin, message } from 'antd';
import StandardTable from '../../../components/common/StandardTable';
import { fetchSqlDataWithQuery } from '../../../services/api';

const { Title } = Typography;

interface ConstPipingPgTableDetailsProps {
  tableName: string;
  onBack: () => void;
}

const ConstPipingPgTableDetails: React.FC<ConstPipingPgTableDetailsProps> = ({ tableName, onBack }) => {
  const [columns, setColumns] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!tableName) return;
    const fetchColumnsAndData = async () => {
      setLoading(true);
      try {
        // 1) Get column names from information_schema for schema 'public'
        const colQuery = `SELECT column_name FROM information_schema.columns WHERE table_schema = 'public' AND table_name = '${tableName}' ORDER BY ordinal_position;`;
        const colResult = await fetchSqlDataWithQuery(colQuery);
        const columnNames: string[] = Array.isArray(colResult) ? colResult.map((r: any) => r.column_name) : [];
        if (columnNames.length === 0) throw new Error('No columns found');

        const tableColumns = columnNames.map((col) => ({
          title: col,
          dataIndex: col,
          key: col,
          width: 150,
          ellipsis: false,
          render: (text: any) => String(text ?? '') || '-',
          exportValue: (row: any) => (row && row[col] != null ? String(row[col]) : ''),
        }));
        setColumns(tableColumns);

        // 2) Fetch data from public.<table>
        const dataQuery = `SELECT * FROM public."${tableName}";`;
        const tableData = await fetchSqlDataWithQuery(dataQuery);
        const formatted = Array.isArray(tableData) ? tableData.map((row, idx) => ({ key: idx, ...row })) : [];
        setData(formatted);
      } catch (err) {
        message.error('Failed to fetch PostgreSQL table details!');
      } finally {
        setLoading(false);
      }
    };
    fetchColumnsAndData();
  }, [tableName]);

  return (
    <Card>
      <Title level={4}>
        <a onClick={onBack} style={{ marginRight: 16, fontSize: 18 }}>&larr; Back</a>
        PG Table Details: public.{tableName}
      </Title>
      {loading ? (
        <Spin />
      ) : (
        <StandardTable
          dataSource={data}
          columns={columns}
          rowKey="key"
          bordered
          scroll={{ x: columns.reduce((sum, col) => sum + (col.width || 150), 0) }}
        />
      )}
    </Card>
  );
};

export default ConstPipingPgTableDetails;
